module.exports = __webpack_public_path__ + "static/img_9801-7417e381b39ec5b2fb954ea148c5ee34.webp";